var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-recaptcha", {
    attrs: { sitekey: this.sitekey, loadRecaptchaScript: true },
    on: {
      verify: _vm.validate,
      expired: function ($event) {
        return _vm.onExpired()
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }